(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchaseItem', PurchaseItem);

    PurchaseItem.$inject = ['$resource'];

    function PurchaseItem ($resource) {
        var resourceUrl =  'api/purchase-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
